import styled from "styled-components"
import padding from "@irati/ui/src/global/padding"

export default styled.div`
  flex: 1;
  ${(props) => props.isSSO && `padding-right: ${padding.base};`}
`
